var VERSION = 1774493953673
export  {
	VERSION
} 
